<template>
  <div class="test-report">
    <base-table ref="table" url="/testReport/get" :toolbar="toolbar" :columns="columns"></base-table>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  name: 'test-report',
  data() {
    return {
      showDialog: false,
      toolbar: {
        formItems: [
          {
            label: '销售店代码',
            prop: 'store_code',
            bind: { style: 'width: 80px' },
            cp: this.$ComparePatterns.Like,
          },
          {
            label: 'VIN码',
            prop: 'vin',
            bind: { style: 'width: 170px' },
            cp: this.$ComparePatterns.Like,
          },
          {
            label: '序列号',
            bind: { style: 'width: 108px' },
            prop: 'sno',
            cp: this.$ComparePatterns.Like,
          },
          {
            label: '上报日期',
            prop: 'time',
            cp: this.$ComparePatterns.Between,
            component: 'el-date-picker',
            bind: {
              style: 'width: 210px',
              type: 'daterange',
              valueFormat: 'yyyy-MM-dd',
            },
          },
          {
            label: '生成日期',
            prop: 'cre_time',
            cp: this.$ComparePatterns.Between,
            component: 'el-date-picker',
            bind: {
              style: 'width: 210px',
              type: 'daterange',
              valueFormat: 'yyyy-MM-dd',
            },
          }
        ],
        buttons: [
          {
            label: '查询',
            on: { click: this.tableSearch },
            bind: { icon: 'el-icon-search', type: 'primary' },
          },
          {
            label: '导出',
            on: { click: this.export },
            bind: { icon: 'el-icon-download' },
          },
        ],
        query: {
          SortFields: JSON.stringify([{ Field: 'time', Order: -1 }]),
        },
      },
      columns: [
        // { bind: { label: 'sa', prop: 'sa' } },
        // { bind: { label: '技师', prop: 'technician' } },
        { bind: { label: '销售店代码', prop: 'store_code' } },
        { bind: { label: '销售店名称', prop: 'store_name' } },
        { bind: { label: '序列号', prop: 'sno' } },
        { bind: { label: '车牌号码', prop: 'plate_number' } },
        { bind: { label: '车型', prop: 'model' } },
        { bind: { label: 'VIN码', prop: 'vin' } },
        { bind: { label: '行驶里程(KM)', prop: 'odometer' } },
        { bind: { label: '生成时间', prop: 'cre_time' } },
        { bind: { label: '上传时间', prop: 'time' } },
        // {
        //   bind: { label: '操作', prop: 'Name', width: 100 },
        //   header: {
        //     component: 'cell-button',
        //     bind: { label: '新建', icon: 'el-icon-plus', type: 'primary' },
        //     on: { click: this.beginAdd },
        //   },
        //   default: {
        //     component: 'cell-buttons',
        //     bind: {
        //       buttons: [
        //         { label: '修改', type: 'text', click: this.beginEdit },
        //         { label: '删除', type: 'text', click: this.delData },
        //       ],
        //     },
        //   },
        // },
      ],
    }
  },
  computed: {
    table() {
      return this.$refs.table
    },
    form() {
      return this.$refs.form
    },
  },
  methods: {
    tableSearch() {
      this.table.query.PageIndex = 1
      this.table.refreshData()
    },
    export() {
      var data = this.table.getSearchData()
      const val = this.table.$refs.toolbar.$refs.form.value
      if (!val.store_code && !val.vin && !val.sno) {
        if ((!val.time || val.time.length < 2) && (!val.cre_time || val.cre_time.length < 2)) {
          this.$message('请选择导出时间范围!')
          return
        }
        if (val.time && val.time.length >= 2) {
          const sbDay = (new Date(val.time[1]) - new Date(val.time[0])) / (24 * 60 * 60 * 1000)
          if (sbDay > 31) {
            this.$message('导出时间范围不能大于31天!')
            return
          }
        }
        if (val.cre_time && val.cre_time.length >= 2) {
          const sbDay = (new Date(val.cre_time[1]) - new Date(val.cre_time[0])) / (24 * 60 * 60 * 1000)
          if (sbDay > 31) {
            this.$message('导出时间范围不能大于31天!')
            return
          }
        }
      }
      window.open('/testReport/export?' + qs.stringify(data))
    },
  },
}
</script>
<style lang="less">
.test-report {
  height: 100%;
}
</style>